const React = require('react')
const { Fragment, useState } = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')
const { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } = require('reactstrap')

require('@styles/pages/address/statistics.address.css')

const TokenItem = ({ token, showDivider, type = false }) => {
    const history = useHistory()
    const { address } = useParams()
    const { network } = useNetworkConfig()

    return (
        <Fragment>
            <div
                className='token-detail'
                onClick={() => history.push(`/${network.name}/token/${token.tokenAddress}?a=${address}`)}
            >
                <div className='token-name-container'>
                    <span style={{ fontWeight: 'bold' }}>{token.tokenName}</span>
                    <span className='token-symbol'>{token.tokenSymbol}</span>
                </div>
                <div className='token-value-container'>
                    {type ? (
                        <div style={{ display: 'inline-flex', gap: '4px' }}>
                            {token.balance > 1 && <span className='token-type-tag'>x{token.balance}</span>}
                            <span className='token-type-tag'>{token.tokenType}</span>
                        </div>
                    ) : (
                        <span style={{ fontWeight: 'bold' }}>
                            {(token.balance / 10 ** 18).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 18
                            })}
                        </span>
                    )}
                </div>
            </div>
            {showDivider && <div className='token-divider' />}
        </Fragment>
    )
}

const TokenDropdown = props => {
    const history = useHistory()
    const { data, onTabChange } = props
    const { network } = useNetworkConfig()

    const [dropdownOpen, setDropdownOpen] = useState(false)

    const toggle = () => setDropdownOpen(prev => !prev)

    const erc20Tokens = data.tokens.items.filter(token => token.tokenType === 'ERC20')
    const nftTokens = data.tokens.items.filter(token => token.tokenType === 'ERC721' || token.tokenType === 'ERC1155')

    return (
        <div style={{ position: 'relative', zIndex: 100 }}>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction='down' className='statistics-dropdown'>
                <DropdownToggle caret>
                    <span>{data.tokens.totalItems} Tokens</span>
                </DropdownToggle>
                <DropdownMenu style={{ padding: '0px' }}>
                    <div className='token-list-container'>
                        <DropdownItem tag='div' key={'ERC-20'}>
                            <div className='token-category-header'>ERC-20 Tokens ({erc20Tokens.length})</div>
                            {erc20Tokens.map(
                                (token, index) =>
                                    token.tokenName && (
                                        <TokenItem
                                            key={token.tokenAddress}
                                            token={token}
                                            showDivider={index < erc20Tokens.length - 1}
                                        />
                                    )
                            )}
                        </DropdownItem>
                        <DropdownItem tag='div' key={'NFT'}>
                            <div className='token-category-header'>NFT Tokens ({nftTokens.length})</div>
                            {nftTokens.map(
                                (token, index) =>
                                    token.tokenName && (
                                        <TokenItem
                                            key={token.tokenAddress}
                                            token={token}
                                            showDivider={index < nftTokens.length - 1}
                                            type={true}
                                        />
                                    )
                            )}
                        </DropdownItem>
                    </div>

                    <div
                        className={`view-all holdings ${network.name}-text-color-after`}
                        onClick={() => {
                            const currentQuery = window.location.search
                            history.push(`${currentQuery}#asset-tokens`)
                            onTabChange('asset-tokens')
                        }}
                    >
                        <i className='fas fa-wallet'></i>
                        View all holdings
                    </div>
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}

module.exports = { TokenDropdown }
